import React from 'react'
import { useDispatch } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal } from '../../../reducers/cloning_steps'

const modalContent = (
  <>
    <span>{window.I18n.t('clone_leagues_sessions.modals.session_in_progress.content_1')}</span>
    <span>{window.I18n.t('clone_leagues_sessions.modals.session_in_progress.content_2')}</span>
  </>
)

const SessionInProgressModal = () => {
  const dispatch = useDispatch()

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.session_in_progress.title')}
    content={modalContent}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.session_in_progress.confirm')}
      onClick={() => dispatch(setCloningModal(null))}
    />}
  />)
}

export default SessionInProgressModal
